// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reports_wrapper {
    padding: 2rem;
    margin: 1rem;
    /* background-color: var(--clr-grey-10); */
    min-height: 100vh;
    border: 3px solid var(--clr-primary-3);
  }
  
  .reports_dashboard {
    max-width: var(--max-width);
    margin: auto;
    background: linear-gradient(
      135deg,
      hsl(210, 36%, 96%) 0%,
      hsl(210, 31%, 85%) 50%,
      hsl(210, 22%, 49%) 100%
    );
    border: 1px solid var(--clr-grey-8);
    border-radius: var(--radius);
    padding: 2rem;
    box-shadow: var(--shadow-2);
  }
  
  
  .reports_heading {
    font-size: 2rem;
    font-weight: 700;
    color: var(--clr-grey-1);
    margin-bottom: 0.5rem;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
  }
  
  .reports_subtext {
    font-size: 1rem;
    color: var(--clr-grey-2);
    margin-bottom: 2rem;
    text-align: center;
    justify-content: center;
    align-items: center;
  }
  
  .reports_layout {
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
  }
  
  /* Sidebar */
  .reports_sidebar {
    min-width: 260px;
    max-height: 500px;
    overflow-y: auto;
    /* background-color: var(--clr-primary-10); */
    padding: 1rem;
    border-radius: var(--radius);
    box-shadow: var(--shadow-1);
    flex: 1 1;
    border: 2px solid var(--clr-primary-4);
  }
  
  
  .report_list_scrollable {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .report_item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0.65rem 1rem;
    border-radius: var(--radius);
    font-weight: 500;
    font-size: 0.95rem;
    color: var(--clr-grey-1);
    cursor: pointer;
    position: relative;
    z-index: 1;
    transition: var(--transition);
    background-color: transparent;
  }
  
  .report_item:hover {
    background-color: var(--clr-primary-7);
    color: var(--clr-grey-1);
    z-index: 2;
  }
  
  .report_item.active {
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
    z-index: 3;
    font-weight: 600;
  }
  
  .report_item:not(:last-child) {
    margin-bottom: 0.25rem;
  }
  
  .report_icon {
    font-size: 1rem;
    opacity: 0.8;
  }
  
  
  /* Main Content */
  .reports_content {
    flex: 2 1;
    /* min-width: 300px; */
  }
  
  .report_card {
    max-width: var(--fixed-width);
    background-color: var(--clr-grey-8);
    padding: 1.75rem;
    border-radius: var(--radius);
    box-shadow: var(--shadow-1);
    border: 1px solid var(--clr-primary-4);
  }
  
  .report_card h2 {
    font-size: 1.4rem;
    font-weight: 600;
    color: var(--clr-grey-2);
    margin-bottom: 0.5rem;
  }
  
  .report_description {
    /* font-size: var(--small-text); */
    color: var(--clr-grey-2);
    margin-bottom: 1.5rem;
  }
  
  /* Filters */
  .date_filter_row {
    display: flex;
    flex-wrap: wrap;
    gap: 1.25rem;
    align-items: flex-end;
  }
  
  .date_input_block {
    display: flex;
    flex-direction: column;
    flex: 1 1;
  }
  
  .date_input_block label {
    font-size: 1rem;
    color: var(--clr-grey-2);
    margin-bottom: 0.3rem;
  }
  
  .input_with_icon {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    border: 1px solid var(--clr-grey-7);
    padding: 0.5rem 0.75rem;
    border-radius: var(--radius);
    background-color: var(--clr-white);
  }
  
  .input_with_icon input {
    border: none;
    outline: none;
    background: transparent;
    flex: 1 1;
    font-size: 0.95rem;
    color: var(--clr-grey-1);
  }
  
  /* Download Button */
  .download_btn {
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
    padding: 0.7rem 1.4rem;
    font-size: 1rem;
    border-radius: var(--radius);
    border: none;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    transition: var(--transition);
  }
  
  .download_btn:hover {
    background-color: var(--clr-primary-4);
  }
  
  .no_report_text {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
    text-align: left;
    padding: 2rem 1.5rem;
    font-size: 1.1rem;
    font-weight: 500;
    color: var(--clr-grey-4);
    background-color: var(--clr-grey-9);
    border-radius: var(--radius);
    margin-top: 1rem;
    box-shadow: var(--shadow-1);
    max-width: 100%;
  }
  
  .no_report_text::before {
    content: '';
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 12px solid var(--clr-primary-4); /* darker arrow */
    animation: pulseArrow 1.5s ease-in-out infinite;
  }
  
  @keyframes pulseArrow {
    0% {
      transform: translateX(0);
      opacity: 1;
    }
    50% {
      transform: translateX(3px);
      opacity: 0.9;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  
  @media screen and (max-width: 768px) {
    .report_card {
      max-width: 100%;
      width: 100%;
      margin: 0 auto;
      padding: 1.25rem;
      box-shadow: none;
      background-color: var(--clr-grey-10);
      border-radius: var(--radius);
      border: 1px solid var(--clr-primary-4);
    }
  
    .no_report_text {
      max-width: 100%;
      width: 100%;
      margin: 1rem auto 0 auto;
      padding: 1.25rem;
      font-size: 1rem;
      flex-direction: column;
      align-items: flex-start;
      text-align: left;
      box-shadow: none;
    }
  
    .no_report_text::before {
      display: none; /* Remove animated arrow in mobile */
    }
  }
  
  /* ----------------------------- */
  /* Responsive Styles */
  /* ----------------------------- */
  
  @media (max-width: 1024px) {
    .reports_layout {
      flex-direction: column;
    }
  
    .reports_sidebar {
      max-height: none;
      width: 100%;
    }
  
    .reports_content {
      width: 100%;
    }
  
    .report_card {
      max-width: 100%;
    }
  
    .date_filter_row {
      flex-direction: column;
      align-items: stretch;
    }
  
    .download_btn {
      width: 100%;
      justify-content: center;
    }
  }
  
  @media (max-width: 600px) {
    .reports_heading {
      font-size: 1.6rem;
      text-align: center;
    }
  
    .reports_subtext {
      text-align: center;
      font-size: 0.95rem;
      margin-bottom: 1.5rem;
    }
  
    .report_card {
      padding: 1.25rem;
    }
  
    .input_with_icon {
      padding: 0.45rem 0.75rem;
    }
  
    .download_btn {
      padding: 0.6rem 1rem;
      font-size: 0.95rem;
    }
  }
  
  .icon-spin {
    display: inline-block;
    animation: spin 1.5s linear infinite;
    margin-right: 0.5rem;
    color: var(--clr-primary-5); 
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  

  .download-summary_v1 {
    margin-top: 1rem;
    background-color: var(--clr-primary-10);
    border: 1px solid var(--clr-grey-8);
    padding: 1rem 1.25rem;
    border-radius: var(--radius);
    position: relative;
    color: var(--clr-grey-2);
    font-size: 0.95rem;
    box-shadow: var(--shadow-1);
    animation: fadeIn 0.3s ease-in-out;
  }
  
  .summary-close-btn_v1 {
    position: absolute;
    top: 6px;
    right: 10px;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1rem;
    color: var(--clr-grey-5);
    transition: color 0.2s;
  }
  
  .summary-close-btn_v1:hover {
    color: var(--clr-grey-2);
  }
  
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(8px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  
  @media screen and (max-width: 768px) {
    .download-summary_v1 {
      width: 100%;
      padding: 1rem;
      font-size: 0.9rem;
      border-radius: var(--radius);
      box-shadow: none;
      margin-top: 1rem;
      position: relative;
      word-wrap: break-word;
    }
  
    .summary-close-btn_v1 {
      top: 8px;
      right: 8px;
      font-size: 0.95rem;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Reports/ReportsPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ,0CAA0C;IAC1C,iBAAiB;IACjB,sCAAsC;EACxC;;EAEA;IACE,2BAA2B;IAC3B,YAAY;IACZ;;;;;KAKC;IACD,mCAAmC;IACnC,4BAA4B;IAC5B,aAAa;IACb,2BAA2B;EAC7B;;;EAGA;IACE,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;EACX;;EAEA,YAAY;EACZ;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,6CAA6C;IAC7C,aAAa;IACb,4BAA4B;IAC5B,2BAA2B;IAC3B,SAAO;IACP,sCAAsC;EACxC;;;EAGA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,6BAA6B;IAC7B,6BAA6B;EAC/B;;EAEA;IACE,sCAAsC;IACtC,wBAAwB;IACxB,UAAU;EACZ;;EAEA;IACE,sCAAsC;IACtC,uBAAuB;IACvB,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;;EAGA,iBAAiB;EACjB;IACE,SAAO;IACP,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;IAC7B,mCAAmC;IACnC,gBAAgB;IAChB,4BAA4B;IAC5B,2BAA2B;IAC3B,sCAAsC;EACxC;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;IACE,kCAAkC;IAClC,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA,YAAY;EACZ;IACE,aAAa;IACb,eAAe;IACf,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAO;EACT;;EAEA;IACE,eAAe;IACf,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mCAAmC;IACnC,uBAAuB;IACvB,4BAA4B;IAC5B,kCAAkC;EACpC;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,SAAO;IACP,kBAAkB;IAClB,wBAAwB;EAC1B;;EAEA,oBAAoB;EACpB;IACE,sCAAsC;IACtC,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,4BAA4B;IAC5B,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,mCAAmC;IACnC,4BAA4B;IAC5B,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,qCAAqC;IACrC,6CAA6C,EAAE,iBAAiB;IAChE,+CAA+C;EACjD;;EAEA;IACE;MACE,wBAAwB;MACxB,UAAU;IACZ;IACA;MACE,0BAA0B;MAC1B,YAAY;IACd;IACA;MACE,wBAAwB;MACxB,UAAU;IACZ;EACF;;EAEA;IACE;MACE,eAAe;MACf,WAAW;MACX,cAAc;MACd,gBAAgB;MAChB,gBAAgB;MAChB,oCAAoC;MACpC,4BAA4B;MAC5B,sCAAsC;IACxC;;IAEA;MACE,eAAe;MACf,WAAW;MACX,wBAAwB;MACxB,gBAAgB;MAChB,eAAe;MACf,sBAAsB;MACtB,uBAAuB;MACvB,gBAAgB;MAChB,gBAAgB;IAClB;;IAEA;MACE,aAAa,EAAE,oCAAoC;IACrD;EACF;;EAEA,kCAAkC;EAClC,sBAAsB;EACtB,kCAAkC;;EAElC;IACE;MACE,sBAAsB;IACxB;;IAEA;MACE,gBAAgB;MAChB,WAAW;IACb;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,sBAAsB;MACtB,oBAAoB;IACtB;;IAEA;MACE,WAAW;MACX,uBAAuB;IACzB;EACF;;EAEA;IACE;MACE,iBAAiB;MACjB,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;MAClB,kBAAkB;MAClB,qBAAqB;IACvB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;MACE,oBAAoB;MACpB,kBAAkB;IACpB;EACF;;EAEA;IACE,qBAAqB;IACrB,oCAAoC;IACpC,oBAAoB;IACpB,2BAA2B;EAC7B;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;;;EAGA;IACE,gBAAgB;IAChB,uCAAuC;IACvC,mCAAmC;IACnC,qBAAqB;IACrB,4BAA4B;IAC5B,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,wBAAwB;IACxB,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;IAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;EAC/C;;EAEA;IACE;MACE,WAAW;MACX,aAAa;MACb,iBAAiB;MACjB,4BAA4B;MAC5B,gBAAgB;MAChB,gBAAgB;MAChB,kBAAkB;MAClB,qBAAqB;IACvB;;IAEA;MACE,QAAQ;MACR,UAAU;MACV,kBAAkB;IACpB;EACF","sourcesContent":[".reports_wrapper {\n    padding: 2rem;\n    margin: 1rem;\n    /* background-color: var(--clr-grey-10); */\n    min-height: 100vh;\n    border: 3px solid var(--clr-primary-3);\n  }\n  \n  .reports_dashboard {\n    max-width: var(--max-width);\n    margin: auto;\n    background: linear-gradient(\n      135deg,\n      hsl(210, 36%, 96%) 0%,\n      hsl(210, 31%, 85%) 50%,\n      hsl(210, 22%, 49%) 100%\n    );\n    border: 1px solid var(--clr-grey-8);\n    border-radius: var(--radius);\n    padding: 2rem;\n    box-shadow: var(--shadow-2);\n  }\n  \n  \n  .reports_heading {\n    font-size: 2rem;\n    font-weight: 700;\n    color: var(--clr-grey-1);\n    margin-bottom: 0.5rem;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 0.5rem;\n  }\n  \n  .reports_subtext {\n    font-size: 1rem;\n    color: var(--clr-grey-2);\n    margin-bottom: 2rem;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n  }\n  \n  .reports_layout {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 2rem;\n  }\n  \n  /* Sidebar */\n  .reports_sidebar {\n    min-width: 260px;\n    max-height: 500px;\n    overflow-y: auto;\n    /* background-color: var(--clr-primary-10); */\n    padding: 1rem;\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-1);\n    flex: 1;\n    border: 2px solid var(--clr-primary-4);\n  }\n  \n  \n  .report_list_scrollable {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  }\n  \n  .report_item {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 0.65rem 1rem;\n    border-radius: var(--radius);\n    font-weight: 500;\n    font-size: 0.95rem;\n    color: var(--clr-grey-1);\n    cursor: pointer;\n    position: relative;\n    z-index: 1;\n    transition: var(--transition);\n    background-color: transparent;\n  }\n  \n  .report_item:hover {\n    background-color: var(--clr-primary-7);\n    color: var(--clr-grey-1);\n    z-index: 2;\n  }\n  \n  .report_item.active {\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n    z-index: 3;\n    font-weight: 600;\n  }\n  \n  .report_item:not(:last-child) {\n    margin-bottom: 0.25rem;\n  }\n  \n  .report_icon {\n    font-size: 1rem;\n    opacity: 0.8;\n  }\n  \n  \n  /* Main Content */\n  .reports_content {\n    flex: 2;\n    /* min-width: 300px; */\n  }\n  \n  .report_card {\n    max-width: var(--fixed-width);\n    background-color: var(--clr-grey-8);\n    padding: 1.75rem;\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-1);\n    border: 1px solid var(--clr-primary-4);\n  }\n  \n  .report_card h2 {\n    font-size: 1.4rem;\n    font-weight: 600;\n    color: var(--clr-grey-2);\n    margin-bottom: 0.5rem;\n  }\n  \n  .report_description {\n    /* font-size: var(--small-text); */\n    color: var(--clr-grey-2);\n    margin-bottom: 1.5rem;\n  }\n  \n  /* Filters */\n  .date_filter_row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1.25rem;\n    align-items: flex-end;\n  }\n  \n  .date_input_block {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n  }\n  \n  .date_input_block label {\n    font-size: 1rem;\n    color: var(--clr-grey-2);\n    margin-bottom: 0.3rem;\n  }\n  \n  .input_with_icon {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    border: 1px solid var(--clr-grey-7);\n    padding: 0.5rem 0.75rem;\n    border-radius: var(--radius);\n    background-color: var(--clr-white);\n  }\n  \n  .input_with_icon input {\n    border: none;\n    outline: none;\n    background: transparent;\n    flex: 1;\n    font-size: 0.95rem;\n    color: var(--clr-grey-1);\n  }\n  \n  /* Download Button */\n  .download_btn {\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n    padding: 0.7rem 1.4rem;\n    font-size: 1rem;\n    border-radius: var(--radius);\n    border: none;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    cursor: pointer;\n    transition: var(--transition);\n  }\n  \n  .download_btn:hover {\n    background-color: var(--clr-primary-4);\n  }\n  \n  .no_report_text {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.75rem;\n    text-align: left;\n    padding: 2rem 1.5rem;\n    font-size: 1.1rem;\n    font-weight: 500;\n    color: var(--clr-grey-4);\n    background-color: var(--clr-grey-9);\n    border-radius: var(--radius);\n    margin-top: 1rem;\n    box-shadow: var(--shadow-1);\n    max-width: 100%;\n  }\n  \n  .no_report_text::before {\n    content: '';\n    width: 0;\n    height: 0;\n    border-top: 10px solid transparent;\n    border-bottom: 10px solid transparent;\n    border-right: 12px solid var(--clr-primary-4); /* darker arrow */\n    animation: pulseArrow 1.5s ease-in-out infinite;\n  }\n  \n  @keyframes pulseArrow {\n    0% {\n      transform: translateX(0);\n      opacity: 1;\n    }\n    50% {\n      transform: translateX(3px);\n      opacity: 0.9;\n    }\n    100% {\n      transform: translateX(0);\n      opacity: 1;\n    }\n  }\n  \n  @media screen and (max-width: 768px) {\n    .report_card {\n      max-width: 100%;\n      width: 100%;\n      margin: 0 auto;\n      padding: 1.25rem;\n      box-shadow: none;\n      background-color: var(--clr-grey-10);\n      border-radius: var(--radius);\n      border: 1px solid var(--clr-primary-4);\n    }\n  \n    .no_report_text {\n      max-width: 100%;\n      width: 100%;\n      margin: 1rem auto 0 auto;\n      padding: 1.25rem;\n      font-size: 1rem;\n      flex-direction: column;\n      align-items: flex-start;\n      text-align: left;\n      box-shadow: none;\n    }\n  \n    .no_report_text::before {\n      display: none; /* Remove animated arrow in mobile */\n    }\n  }\n  \n  /* ----------------------------- */\n  /* Responsive Styles */\n  /* ----------------------------- */\n  \n  @media (max-width: 1024px) {\n    .reports_layout {\n      flex-direction: column;\n    }\n  \n    .reports_sidebar {\n      max-height: none;\n      width: 100%;\n    }\n  \n    .reports_content {\n      width: 100%;\n    }\n  \n    .report_card {\n      max-width: 100%;\n    }\n  \n    .date_filter_row {\n      flex-direction: column;\n      align-items: stretch;\n    }\n  \n    .download_btn {\n      width: 100%;\n      justify-content: center;\n    }\n  }\n  \n  @media (max-width: 600px) {\n    .reports_heading {\n      font-size: 1.6rem;\n      text-align: center;\n    }\n  \n    .reports_subtext {\n      text-align: center;\n      font-size: 0.95rem;\n      margin-bottom: 1.5rem;\n    }\n  \n    .report_card {\n      padding: 1.25rem;\n    }\n  \n    .input_with_icon {\n      padding: 0.45rem 0.75rem;\n    }\n  \n    .download_btn {\n      padding: 0.6rem 1rem;\n      font-size: 0.95rem;\n    }\n  }\n  \n  .icon-spin {\n    display: inline-block;\n    animation: spin 1.5s linear infinite;\n    margin-right: 0.5rem;\n    color: var(--clr-primary-5); \n  }\n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n  \n\n  .download-summary_v1 {\n    margin-top: 1rem;\n    background-color: var(--clr-primary-10);\n    border: 1px solid var(--clr-grey-8);\n    padding: 1rem 1.25rem;\n    border-radius: var(--radius);\n    position: relative;\n    color: var(--clr-grey-2);\n    font-size: 0.95rem;\n    box-shadow: var(--shadow-1);\n    animation: fadeIn 0.3s ease-in-out;\n  }\n  \n  .summary-close-btn_v1 {\n    position: absolute;\n    top: 6px;\n    right: 10px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    font-size: 1rem;\n    color: var(--clr-grey-5);\n    transition: color 0.2s;\n  }\n  \n  .summary-close-btn_v1:hover {\n    color: var(--clr-grey-2);\n  }\n  \n  @keyframes fadeIn {\n    from { opacity: 0; transform: translateY(8px); }\n    to   { opacity: 1; transform: translateY(0); }\n  }\n  \n  @media screen and (max-width: 768px) {\n    .download-summary_v1 {\n      width: 100%;\n      padding: 1rem;\n      font-size: 0.9rem;\n      border-radius: var(--radius);\n      box-shadow: none;\n      margin-top: 1rem;\n      position: relative;\n      word-wrap: break-word;\n    }\n  \n    .summary-close-btn_v1 {\n      top: 8px;\n      right: 8px;\n      font-size: 0.95rem;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
